import { objectToSearchString } from '@at/formatter-utils';
import { getNetworkIdFromCookie, getSessionIdFromCookie, getUrsDatabaseIdFromCookie } from '../bundle/utils';
export const appendUserIdentifiers = (odsData) => {
    const ursDbId = getUrsDatabaseIdFromCookie();
    const sessionId = getSessionIdFromCookie();
    const networkId = getNetworkIdFromCookie();
    return Object.assign(Object.assign({}, odsData), { sessionId: sessionId, networkId: networkId, ursDatabaseId: ursDbId });
};
export const trackOds = (odsData) => {
    fetch(`/json/ods/track?${objectToSearchString(appendUserIdentifiers(odsData))}`, {
        credentials: 'same-origin',
    })
        .then((response) => response)
        .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
    });
};
export const trackOdsAdblockWhitelist = (odsData) => {
    fetch(`/json/ods/track-unblocked?${objectToSearchString(appendUserIdentifiers(odsData))}`, {
        credentials: 'same-origin',
    })
        .then((response) => response)
        .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
    });
};
